
import React, { useCallback, useRef, useState } from 'react';
import { connect, useIntl } from 'umi';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { Select } from 'tea-component';
import { FILTER_CACHE_VALUE_KEY, storage } from '@/utils/utils';
import { formatCacheValue, setFilterCacheValue } from '../../components/NewFilter/util';
import { useFilterData } from './hooks';
import "@/pages/dashboard/assets/scss/page/comparison/nightingaleDateComparison.scss";
import { getDateDefault } from '../../utils/dateUtils';

/**
 * 
 * @param props 
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns 
 */

const NightingaleRetentionFilter = (props: any) => {
  const { buttonLogConfig, filterConfirm, filterReset, setFilterLoading, filterInit, openSticky = false, gameCode, isHaveFilterSave, data, children, changeData, path, timeZone = 0 } = props;
  const { formatMessage } = useIntl();
  const filterCacheValue = storage.getItem(FILTER_CACHE_VALUE_KEY, 'sessionStorage');
  const keyDaysInit = filterCacheValue?.value?.metric?.toString() || '30';

  const [keyDays, setKeyDays] = useState<string>(keyDaysInit);
  const KEY_DAYS_OPTIONS = [
    {
      value: '30',
      text: formatMessage({ id: 'nightingale_comparison_analysis_d1_d30' }),
      tooltip: "",
    },
    {
      value: '60',
      text: formatMessage({ id: 'nightingale_comparison_analysis_d1_d60' })
    },
    {
      value: '90',
      text: formatMessage({ id: 'nightingale_comparison_analysis_d1_d90' }),
    }

  ];

  const { loading, selector } = useFilterData(path, 'daily');
  const { latestDate } = selector || {};
  const defaultDate = getDateDefault({ timeType: 'day', timeZone, singleNum: 1, isSingle: true});
  // 设置inputList
  const inputList = [
    {
      type: 'singleDaily',
      key: 'singleDaily',
      
      default: defaultDate,
    },
    {
      type: 'contrastDaily',
      key: 'contrastDaily',
      default: defaultDate,
    },
    {
      type: "zone",
      key: "zone",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: 'region',
      key: "region",
      isUseConfig: true,
      // visible: 1,
      default: {
        markets: ['255'],
        region_type: 'market'
      },
    },
    {
      type: "channel",
      key: "channel",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: "system",
      key: "system",
      isUseConfig: true,
      // visible: 1,
      default: [
        "255"
      ],
    },
    {
      type: "lang",
      key: "lang",
      isUseConfig: true,
      // visible: 0,
      default: ["255"]
    },
    {
      type: 'metric',
      key: 'metric',
      default: 30,
      render: () => <Select
        className='search-item'
        boxClassName='register-table-select-box'
        appearance="button"
        matchButtonWidth
        options={KEY_DAYS_OPTIONS}
        value={keyDays}
        button={
          <div className={`selector-multiple__header select-button`}>
            <span className="select-button-text dbd-select-button-text">
              {formatMessage({ id: 'nightingale_comparison_analysis_metrics' })}&nbsp;
            </span>
            <span className='select-button-value'>
              {KEY_DAYS_OPTIONS?.find(item => item?.value === keyDays)?.text || ''}
            </span>
          </div>}
        onChange={(value) => {
          setKeyDays(value);
        }}
        placeholder={formatMessage({ id: 'engagement_retention_keydays' })}
      />
    }
  ];
  const filterValueRef = useRef<any>(null);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, contrastDaily, ...restValue } = value;
    filterInit({
      ...restValue,
      statisticDate: singleDaily,
      contrastDate: contrastDaily,
      metric: keyDays,
      pagePath: path,
    });
    setFilterLoading(false);
  }, [filterInit]);

  const onConfirm = (value: any, realInputList: any) => {
    filterValueRef.current = value;
    const { singleDaily, contrastDaily, ...restValue } = value;
    const obj: any = {
      ...restValue,
      statisticDate: singleDaily,
      contrastDate: contrastDaily,
      metric: keyDays,
      pagePath: path,
    };
    const formatValue = formatCacheValue(realInputList, value) || {};
    setFilterCacheValue({ ...formatValue, metric: keyDays }, gameCode);
    filterConfirm(obj);
    setBtnPointLog(buttonLogConfig, obj);
  };

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, contrastDaily, ...restValue } = value;
    const obj: any = {
      ...restValue,
      statisticDate: singleDaily,
      contrastDate: contrastDaily,
      metric: '30',
      pagePath: path,
    };
    setKeyDays('30');
    filterReset(obj);
    setBtnPointLog(buttonLogConfig, obj, true);
  }, [filterReset]);

  return (
    <span className={'retentionComparison'}>
      <Filter
        path={path}
        openSticky={openSticky}
        latestDateType={''}
        value={filterValueRef.current}
        inputList={inputList}
        onInit={onInit}
        onConfirm={onConfirm}
        onReset={onReset}
        outLatestDate={latestDate}
        outSelector={selector}
        // onChange={onChange}
        loading={loading}
        isHaveFilterSave={isHaveFilterSave}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            data,
            changeData,
          }
        ))}
      </Filter>
    </span>
  );
};


export default connect((state: any) => ({
  gameCode: state.dashboard?.currentGame?.game_code,
}))(NightingaleRetentionFilter);